<template>
  <div>
    <div id="css"></div>
    <div v-if="fin" class="hero is-fullheight">
      <div class="hero-body">
        <div class="container">
          <Logo />
          <h1 class="title has-text-white">Votre commande a été enregistrée.</h1>
          <h2
            class="subtitle"
          >Vous allez recevoir un email de confirmation dans les minutes qui viennent.</h2>
        </div>
      </div>
    </div>
    <div v-else>
      <div v-if="currentSupport" id="titre">
        <template v-if="$route.query.full">
          <div class="qiota_sub"></div>
        </template>
        <template v-else>
          <div class="columns">
            <div class="column">
              <p
                style="margin-top: 100px"
                class="title has-text-grey-light"
                v-html="currentBouton.titre"
              ></p>
              <p class="subtitle has-text-grey-light" v-html="currentBouton.description"></p>

              <div v-if="currentBouton.illustration">
                <img :src="currentBouton.illustration" />
              </div>
            </div>
            <div class="column">
              <div class="qiota_sub"></div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  metaInfo() {
    if (this.currentSupport) {
      return this.setMeta({
        title: this.currentSupport.nom + " - " + this.currentBouton.titre,
        description: this.currentBouton.description,
        image: this.currentBouton.socialImage || this.currentSupport.logoSvgUrl,
      });
    }
  },

  data() {
    return {
      fin: false,
    };
  },
  mounted() {
    this.fin = this.$route.query.fin;
    setTimeout(() => {
      if (this.fin) {
        let purchase = {
          montant: this.currentBouton.montant,
          id: this.currentBouton.code_qiota,
          nom: this.currentBouton.titre,
        };
        this.facebookPixel(purchase);
      } else {
        if (this.currentBouton) {
          if (this.currentBouton.css) {
            document.querySelector("#css").innerHTML = "<style>" + this.currentBouton.css + "</style>";
          }
          if (this.currentBouton.js) {
            eval(this.currentBouton.js);
          }
        }

        this.facebookPixel();

        this.loadQiota();
      }
      this.matomo(
        {
          price: this.currentBouton.montant,
          id: this.currentBouton.code_qiota,
          name: this.currentBouton.titre,
          category: this.currentBouton.type,
        },
        this.fin
      );
    }, 500);
  },
  methods: {
    loadQiota() {
      if (this.currentBouton.code_qiota) {
        q_token = "fJzka25wGW";
        //				q_urlcallback = this.siteUrl()+'/fin?';
        q_urlcallback = document.location.href.split("?")[0] + "?fin=true";
        q_name = this.currentBouton.code_qiota;
        q_logo = this.currentSupport.logoSvgUrl;
        q_title = "";
        // q_title = this.currentSupport.nom+' - '+this.currentSupport.description;
        q_text1 = this.currentBouton.titre;
        q_text2 = "Vos coordonnées";
        q_text3 = "Paiement";

        console.log({
          q_token,
          q_urlcallback,
          q_name,
          q_logo,
          q_title,
          q_text1,
          q_text2,
          q_text3,
        });
        renderQiotaSub(q_token, q_urlcallback);
      }
    },
  },
};
</script>

<style lang="scss">
.title svg {
  width: 100px;
}
#titre .logo svg {
  fill: white;
}
#qiotapay_sub {
  width: 100% !important;
}
</style>